import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'

export default class Select extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func
  }

  state = {}

  componentDidMount() {
    this.setState({validation: this.props.value || ''})
  }

  @autobind
  save() {
    this.props.onChange(this.state.validation)
  }

  render() {
    return (
      <div className={styles.container}>
        <div>Validación (opcional)</div>
        <select
          name="validation"
          className={styles.input}
          onChange={event => this.setState({validation: event.target.value})}
          value={this.state.validation}
          onBlur={this.save}
        >
          <option value="ninguno">Ninguno</option>
          <option value="rut">Rut</option>
          <option value="email">Email</option>
          <option value="telefono">Teléfono</option>
        </select>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/PrepareTemplate/Field/Menu/Select/index.js